import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

import DemoAccordion from './components/DemoAccordion';
import Recipes from './components/Recipes';

jQuery(document).ready(function ($) {
    const ReactComponents = {
        init() {
            this._initDemoAccordion();
            this._initRecipes();
        },
        _initDemoAccordion() {
            const demoAccordionDomNode = document.getElementById('component-demo-accordion');
            if (demoAccordionDomNode) {
                const root = createRoot(demoAccordionDomNode);

                root.render(
                    <DemoAccordion />
                );
            }
        },
        _initRecipes() {
            const recipesDomNode = document.getElementById('component--recipes');
            if (recipesDomNode) {
                const root = createRoot(recipesDomNode);

                root.render(
                    <Recipes />
                );
            }
        },
    };
    ReactComponents.init();
});
